import { IconButton } from '@components/index';
import { TableRowActions } from '@features/TableRowActions/ui/TableRowActions';
import FingerIcon from '@icons/FingerIcon/FingerIcon';
import { FeedbackType } from '../model/types';
import styles from './FeedbackTypeItem.module.scss';

type PropsT = {
  feedback_type: FeedbackType;
};

function FeedbackTypeItem({ feedback_type }: PropsT) {
  return (
    <TableRowActions style={{ justifyContent: 'flex-start', width: '100%' }}>
      <IconButton
        className={
          feedback_type === FeedbackType.Positive
            ? styles.button
            : styles.button_rotated
        }
        variant="underline"
      >
        <FingerIcon
          stroke={
            feedback_type === FeedbackType.Positive ? '#12B76A' : '#F04438'
          }
        />
      </IconButton>
    </TableRowActions>
  );
}

export { FeedbackTypeItem };
